import { USER_ROLE } from '~/shared/constants';
import type { StudentPolicyContext } from '~/shared/permissions/types';

export function canStudent(user, permission, ctx: StudentPolicyContext = { student: null }) {
  const student = ctx.student;

  switch (permission) {
    case 'student.view':
      return [USER_ROLE.ADMIN, USER_ROLE.MANAGER, USER_ROLE.SUPER_TEACHER, USER_ROLE.TEACHER].includes(user.role);

    case 'student.edit':
      return [USER_ROLE.ADMIN, USER_ROLE.SUPER_TEACHER].includes(user.role);

    case 'student.assign':
      return [USER_ROLE.ADMIN, USER_ROLE.MANAGER, USER_ROLE.SUPER_TEACHER].includes(user.role);

    case 'student.view_own_profile':
      return user.role === USER_ROLE.STUDENT && student?._id === user._id;

    default:
      return false;
  }
}
